import { render, staticRenderFns } from "./BuilderSection.vue?vue&type=template&id=58340419&"
import script from "./BuilderSection.vue?vue&type=script&lang=js&"
export * from "./BuilderSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports